<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <!-- <el-dialog
    title="请完成安全验证"
    :footer="false"
    :visible.sync="visible"
    width="300px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  > -->
  <div>
    <div :style="{ minHeight: '200px', width: imgWidth + 'px' }">
      <div class="relative" v-if="picPaylod.bgImage">
        <img :src="'data:image/png;base64,' + picPaylod.bgImage" alt="" />
        <img
          :src="'data:image/png;base64,' + picPaylod.blockImage"
          alt=""
          :style="{ position: 'absolute', top: '0', left: moveX + 'px' }"
        />
        <transition name="slide-in-out" mode="out-in">
          <div class="tips" v-if="showTip" :style="{ backgroundColor: tips.bg }">
            {{ tips.msg }}
          </div>
        </transition>
      </div>
    </div>
    <div class="auth-control_">
      <div class="range-box" :style="{ width: imgWidth + 'px' }">
        <div class="range-text">拖滑块完成拼图</div>
        <div
          class="range-slider"
          :style="{ width: siderWidth + 'px' }"
          ref="sliderRef"
          @mousedown="handleMouseDown"
          :class="{ ani: !moving }"
        >
          <div class="range-btn" :class="{ isDown: moving }" :style="{ width: slideBlockWidth + 'px' }">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </el-dialog> -->
</template>

<script>
import { getBase64ImageSize } from './constants';
import { encryptDistance } from '@/utils/distance-encrypt';
export default {
  props: {
    mobile: { type: String, default: '' }, // 验证类型
  },
  computed: {
    tips() {
      return this.result === 'success' ? { msg: '验证成功', bg: 'green' } : { msg: '验证失败，请重试', bg: 'red' };
    },
  },
  data() {
    return {
      imgWidth: 400,
      cutBlockWidth: 110,
      slideBlockWidth: 50,
      visible: false,
      moving: false,
      siderWidth: 50,
      moveX: 0,
      picPaylod: {},
      loading: false,
      result: 'init',
      showTip: false,
    };
  },
  created() {
    this.getNewPic();
  },
  methods: {
    openModal() {
      this.visible = true;
      this.getNewPic();
    },
    getNewPic() {
      this.moveX = 0; // 滑块位置归零。
      this.siderWidth = this.slideBlockWidth;
      this.loading = true;
      this.imgWidth = 400;
      this.cutBlockWidth = 110;
      this.$api.captcha.getVerifyPic({ captchaType: 'SLIDE_PUZZLE', data: this.mobile }).then((res) => {
        this.picPaylod = res;
        this.loading = false;
        const bgImgSize = getBase64ImageSize('data:image/jpeg;base64,' + this.picPaylod.bgImage);
        this.imgWidth = bgImgSize.width;
        const blockImgSize = getBase64ImageSize('data:image/png;base64,' + this.picPaylod.blockImage);
        this.cutBlockWidth = blockImgSize.width;
      });
    },
    handleMouseDown(evt) {
      const downX = evt.clientX;
      const mouseMoveHandler = (ev) => {
        this.moving = true;
        const movedX = ev.clientX - downX;

        if (movedX > 0) {
          this.siderWidth = this.slideBlockWidth + movedX; // 固定使用 滑动长度 + 滑块宽度
          this.moveX = movedX;
          // 缺块不能超出背景
          if (movedX > this.imgWidth - this.cutBlockWidth) {
            this.siderWidth = this.imgWidth - this.cutBlockWidth + this.slideBlockWidth; // 滑动区域宽度限制
            this.moveX = this.imgWidth - this.cutBlockWidth; // 限制缺块只能在背景最边缘
          }
        } else {
          this.siderWidth = this.slideBlockWidth;
          this.moveX = 0;
        }
      };

      const mouseUpHandler = () => {
        this.handleMouseUp();
      };

      // eslint-disable-next-line no-undef
      // document.body.onmouseup = this.handleMouseUp();
      // 绑定事件监听器
      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);

      // 将事件监听器存储在组件实例中以便后续移除
      this.mouseMoveHandler = mouseMoveHandler;
      this.mouseUpHandler = mouseUpHandler;
    },
    async handleMouseUp() {
      document.removeEventListener('mousemove', this.mouseMoveHandler);
      document.removeEventListener('mouseup', this.mouseUpHandler);
      //
      this.$api.captcha.verify(this.picPaylod.id, { distance: [encryptDistance(this.moveX, this.picPaylod.challenge)] }).then((res) => {
        // 接口直接返回布尔值：true 表示验证成功，false 表示验证失败
        this.result = res === true ? 'success' : 'fail';
        this.showTip = true;
        this.moving = false;

        setTimeout(() => {
          this.showTip = false;

          if (this.result === 'success') {
            this.visible = false;
            this.$emit('ok', this.picPaylod.id);
          } else {
            this.siderWidth = this.slideBlockWidth;
            this.moveX = 0;
            this.result = 'init';
            this.getNewPic();
          }
        }, 1500);
      });
    },
  },
};
</script>

<style scoped>
.bg-img {
  width: 400px;
  height: 300px;
  background-color: green;
}

.tips {
  width: 100%;
  line-height: 30px;
  font-size: 14px;
  color: #fff;
  text-align: center;
  position: absolute;
  bottom: 90px;
  left: 0;
}

.block-img {
  width: 30px;
  height: 300px;
  background-color: red;
  position: absolute;
  top: 0;
}
.auth-control_ .range-box {
  position: relative;
  height: 50px;
  background-color: #eef1f8;
  margin-top: 20px;
  border-radius: 3px;
  box-shadow: 0 0 8px #f0f0f099 inset;
}
.auth-control_ .range-box .range-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  color: #b7bcd1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  width: 100%;
  user-select: none;
}
.auth-control_ .range-box .range-slider {
  position: absolute;
  height: 100%;
  background-color: #6aa0ffcc;
  border-radius: 3px;
}
.auth-control_ .range-box .ani {
  transition: width 0.5s;
}
.auth-control_ .range-box .range-slider .range-btn {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0;
  height: 100%;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 0 4px #ccc;
  cursor: pointer;
}
.auth-control_ .range-box .range-slider .range-btn > div {
  width: 0;
  height: 40%;
  transition: all 0.2s;
  border: solid 1px #6aa0ff;
}
.auth-control_ .range-box .range-slider .range-btn > div:nth-child(2) {
  margin: 0 4px;
}
.auth-control_ .range-box .range-slider .range-btn:hover > div,
.auth-control_ .range-box .range-slider .isDown > div {
  border: solid 4px transparent;
  height: 0;
  border-right-color: #6aa0ff;
}
.auth-control_ .range-box .range-slider .range-btn:hover > div:nth-child(2),
.auth-control_ .range-box .range-slider .isDown > div:nth-child(2) {
  border-width: 3px;
  height: 0;
  border-radius: 3px;
  margin: 0 6px;
  border: solid 3px #6aa0ff;
}
.auth-control_ .range-box .range-slider .range-btn:hover > div:nth-child(3),
.auth-control_ .range-box .range-slider .isDown > div:nth-child(3) {
  border: solid 4px transparent;
  height: 0;
  border-left-color: #6aa0ff;
}
</style>
